import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, User, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "../../lib/api";
import Logo from "../../components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("kame_token") && localStorage.getItem("kame_role") === "admin") {
      navigate("/admin/dashboard");
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("kame_token", data.token);
      localStorage.setItem("kame_role", data.role);
      toast.success("Přihlášení úspěšné");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-[#151515] border border-[#1f1f1f] text-white rounded-sm pl-11 pr-4 py-3 text-sm focus:border-[#B58A50] outline-none";

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="card-kame p-8">
          <h1 className="font-display text-2xl text-white uppercase text-center">Administrace</h1>
          <p className="text-white/50 text-sm text-center mt-1 mb-7">Přihlaste se pro správu vozidel a rezervací.</p>
          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <User size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/40" />
              <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Uživatelské jméno" className={inputCls} data-testid="admin-username" />
            </div>
            <div className="relative">
              <Lock size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/40" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Heslo" className={inputCls} data-testid="admin-password" />
            </div>
            <button type="submit" disabled={loading} className="btn-gold w-full justify-center disabled:opacity-60" data-testid="admin-login-submit">
              {loading ? "Přihlašuji…" : "Přihlásit se"}
            </button>
          </form>
        </div>
        <Link to="/" className="flex items-center justify-center gap-2 text-white/50 text-sm mt-6 hover:text-[#B58A50]">
          <ArrowLeft size={16} /> Zpět na web
        </Link>
      </div>
    </div>
  );
}
